module.exports = __webpack_public_path__ + "img/B913.79dfe128.jpg";